import { render } from "./ProgrammingLanguagesSubComponent.vue?vue&type=template&id=0abfdea8"
import script from "./ProgrammingLanguagesSubComponent.vue?vue&type=script&lang=js"
export * from "./ProgrammingLanguagesSubComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__